import { PrizeDrawEntryWinnerStatus } from "@/api/backofficeRest/generated/model"
import { IDrawWinner } from "@/models/operations/draw/drawWinner.types"
import { IDrawReward } from "@/models/operations/draw/drawReward.types"

// Rejected slots awaiting replacement (persisted REJECTED rows aren't filled).
export const unfilledRejectedSlots = (
  winners: IDrawWinner[],
  rewards: IDrawReward[],
): number =>
  rewards.reduce((total, reward) => {
    const rewardWinners = winners.filter(
      (winner) => winner.prizeDrawRewardId === reward.id,
    )
    const hasRejected = rewardWinners.some(
      (winner) => winner.status === PrizeDrawEntryWinnerStatus.REJECTED,
    )
    if (!hasRejected) return total
    const filled = rewardWinners.filter(
      (winner) => winner.status !== PrizeDrawEntryWinnerStatus.REJECTED,
    ).length
    return total + Math.max(reward.quantity - filled, 0)
  }, 0)
